import React from 'react';
import {
  Box,
  CircularProgress,
  DialogContent,
  Typography,
} from '@mui/material';

export default function PendingAcceptanceDialogBody({ loading, children }) {
  if (loading) {
    return (
      <DialogContent>
        <Box textAlign="center">
          <CircularProgress size="30px" />
          <Typography>Processing</Typography>
        </Box>
      </DialogContent>
    );
  }

  return children;
}
